<template>
	<div>
		<buttonlist @help="help" ref="SetBtn"></buttonlist>
		<selector :isVisible="false" :isSplitPage=true :postUrl="'Eng/Boms/GetBomBPartList'" @callback="getitembom" ref="inputb"></selector>
		<!--<pickboms :isVisible="itevisibleb" @getitembom="getitembom" ref="input"></pickboms>-->
		<selector :isVisible="itevisibleb" :isSplitPage=true :postUrl="'Eng/Boms/GetBomRPartList'" @callback="getitembom" ref="input"></selector>
		<!-- 物料弹框 -->
		<!-- <pick :isVisible="itevisible" @pick="pick" ref="input"></pick> -->
		<el-row style=" margin: 10px auto;background: white;padding: 10px 20px 5px; line-height: 30px;">
			<el-col :span="20">
				<span>{{ $t('getapi[831]') }}      </span>
				<el-radio v-model="radio" :label="0">{{ $t('getapi[830]') }}</el-radio>
				<el-radio v-model="radio" :label="1">{{ $t('getapi[829]') }}</el-radio>
				<div hidden>
					<span>{{ $t('getapi[828]') }}</span>
					<el-radio v-model="radios" :label="0">{{ $t('getapi[215]') }}</el-radio>
					<el-radio v-model="radios" :label="1">{{ $t('getapi[40]') }}</el-radio>
				</div>
			</el-col>
			<el-col :span="4" style="text-align: right;">
				<el-button size="mini" @click="savae" type="primary">{{ $t('getapi[824]') }}</el-button>
				<!-- <el-button size="mini">{{$t('getapi[441]')}}</el-button> -->
			</el-col>
		</el-row>
		<el-row :gutter="0" style="background-color: #ffffff;">
			<el-col :span="24">
				<el-card class="box-card" :height="tableHeight">
					<div slot="header" class="clearfix">
						<span>{{ $t('getapi[820]') }}</span>
					</div>
					<el-form :model="newitem" label-width="80px" :inline="true">
						<el-form-item :label="$t('getapi[112]')">
							<routejump :urlNo="12">
								<el-input  v-model="newitem.part_code" type="text" size="mini">
									<i class="el-icon-edit el-input__icon" slot="suffix" @click="showitems()"></i>
								</el-input>
							</routejump>
						</el-form-item>
						<el-form-item :label="$t('getapi[116]')"><el-input v-model="newitem.part_name" disabled></el-input></el-form-item>
						<el-form-item :label="$t('getapi[149]')"><el-input v-model="newitem.part_version" disabled></el-input></el-form-item>
						<el-form-item :label="$t('getapi[827]')"><el-input v-model="newitem.item_code" disabled></el-input></el-form-item>
					</el-form>
				</el-card>
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>{{ $t('getapi[821]') }}</span>
					</div>
					<el-form :model="olditem" label-width="80px" :inline="true">
						<el-form-item :label="$t('getapi[112]')">
							<routejump :urlNo="12">
								<el-input  v-model="olditem.part_code" type="text" size="mini">
									<i class="el-icon-edit el-input__icon" slot="suffix" @click="showitem()"></i>
								</el-input>
							</routejump>
						</el-form-item>
						<el-form-item :label="$t('getapi[116]')"><el-input v-model="olditem.part_name" disabled></el-input></el-form-item>
						<el-form-item :label="$t('getapi[149]')"><el-input v-model="olditem.part_version" disabled></el-input></el-form-item>
						<el-form-item :label="$t('getapi[827]')"><el-input v-model="olditem.item_code" disabled></el-input></el-form-item>
					</el-form>
					<el-button size="mini" :disabled="!Downloading" @click="GetBomParentPartsToExecl" type="primary">{{ $t('getapi[12600]') }}</el-button>			 
					<el-table
						:data="datajson"
						v-loading="loading"
						:highlight-current-row="false"
						show-overflow-tooltip="true"
						border
						stripe
						size="mini"
						:height="tableHeight"
						tab-click="selectInfo(0)"
						@selection-change="handleSelectionChange"
						header-row-class-name="headerclass"
						style="width: 100%; margin-top:0px"
						ref="singleTable"
					>
						<el-table-column show-overflow-tooltip type="selection" :label="$t('getapi[824]')" sortable></el-table-column>
						<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" sortable></el-table-column>
						<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" sortable></el-table-column>
						<el-table-column prop="self_level_qty" :label="$t('getapi[826]')" sortable>
							<template slot-scope="scope" sortable>
								<el-input v-model="scope.row.self_level_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.0001"></el-input>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="status" :label="$t('getapi[722]')" sortable></el-table-column>
						<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')" sortable></el-table-column>
						<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[827]')" sortable></el-table-column>
						<el-table-column show-overflow-tooltip prop="parent_part_id" :label="$t('getapi[443]')" sortable></el-table-column>
					</el-table>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name:'replace',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight- 380
        }
    },
	data() {
		return {
			radio: 0,
			radios: 1,
			itemtype:0,
			itevisible: false,
			itevisibleb:false,
			datajson: [],
			selectIDData: '',
			selelist: [],
			olditem: {
				Column1: '',
				Column2: '',
				exclusively_id: '',
				part_code: '',
				part_version: ''
			},
			newitem: {
				Column1: '',
				Column2: '',
				exclusively_id: '',
				part_code: '',
				part_version: ''
			},
			loading: false, // 主表加载状态
			Downloading: false, // 主表加载状态
            scrollTop:0,
		};
	},
	mounted: function() {
		let that = this;
		that.authority()
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })

    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[71]"),this.$t("getapi[18]"));
        },
        authority(){
            let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('');
		},
		handleSelectionChange(val) {
			let that = this;
			that.selelist = val;
			that.selectIDData = '';
			for (let i = 0; i < val.length; i++) {
				that.selectIDData += val[i].Exclusively_Id + ',';
			}
			console.log(that.selectIDData);
		},
		//打开物料选择框
		showitem() {
			this.itemtype = 0;
			this.$refs.inputb.clearInput(true);
		},
		// 新物料打开
		showitems(){
			this.itevisibleb = true;
			this.itemtype = 1;
			this.$refs.input.clearInput(this.itevisibleb);
		},
		//获取物料信息
		pick(val) {
			console.log(val);
			if(this.itemtype==1){
				this.newitem = val;
			}else{
				this.olditem = val;
				this.GetBomParentParts();
			}
		},
		//获取物料信息
		getitembom(val) {
			console.log(val);
			if(this.itemtype==1){
				this.newitem = val;
			}else{
				this.olditem = val;
				this.GetBomParentParts();
			}
		},
		GetBomParentParts() {
			let that = this;
			let parm = {
				id: this.olditem.exclusively_id
			};
			that.$http.urlpost('Eng/Boms/GetBomParentParts', parm, res => {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					if(that.datajson!=null){
						if(that.datajson.length>0){
							that.Downloading=true;
						}
					}
				}
			});
		},
		GetBomParentPartsToExecl() {
			let that = this;
			that.Downloading = false;
			let parm = {
				id: this.olditem.exclusively_id
			};
			that.$http.urlpost('Eng/Boms/GetBomParentPartsToExecl', parm, res => {
				console.log(res);
				if (res.Success == 1) {
					let hrefurl = Common.InUrl + res.DataContent.URL;
                    window.open(hrefurl);
				}
			});
			that.Downloading = true;
		},
		// 替换
		savae() {
			let that = this;
			let parm = {
				IsMergeQty: that.radio==0?1:0,
				IsReplace: that.radio,
				IsDisabled: that.radios==0?1:0,
				IsDel: that.radios,
				OldPartId: that.olditem.exclusively_id,
				NewPartId: that.newitem.exclusively_id,
				List: [],
                LangType: that.$processdata.getLang(),
			};
			parm.List = that.selelist;
			console.log(parm);
			that.$http.urlpost('Eng/Boms/SaveReplaceBomData', parm, res => {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[854]'));
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
	.el-form-item{
		margin-bottom: 0;
	}
</style>
